import { render } from "./px-notice-bar.vue?vue&type=template&id=1355bc9f&scoped=true&ts=true"
import script from "./px-notice-bar.vue?vue&type=script&lang=ts"
export * from "./px-notice-bar.vue?vue&type=script&lang=ts"

import "./px-notice-bar.vue?vue&type=style&index=0&id=1355bc9f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1355bc9f"]])

export default __exports__